var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 2.375,
    width: 16.25,
    height: 16.25,
    rx: 1.625,
    stroke: "black",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.9474C5.71795 8.73079 10.0256 7.59543 11.8205 11.3797M11.8205 11.3797L10.0256 11.0012M11.8205 11.3797L12 9.48753",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0526C11.2821 16.2692 6.97436 17.4046 5.17949 13.6203M5.17949 13.6203L6.97436 13.9988M5.17949 13.6203L5 15.5125",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 1C5.375 0.792893 5.20711 0.625 5 0.625C4.79289 0.625 4.625 0.792893 4.625 1H5.375ZM4.625 4C4.625 4.20711 4.79289 4.375 5 4.375C5.20711 4.375 5.375 4.20711 5.375 4H4.625ZM12.375 1C12.375 0.792893 12.2071 0.625 12 0.625C11.7929 0.625 11.625 0.792893 11.625 1H12.375ZM11.625 4C11.625 4.20711 11.7929 4.375 12 4.375C12.2071 4.375 12.375 4.20711 12.375 4H11.625ZM0.5 6.875H16.5V6.125H0.5V6.875ZM4.625 1V4H5.375V1H4.625ZM11.625 1V4H12.375V1H11.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9a9c9e5543c7d78502d78b72355c3760.svg";
export { ForwardRef as ReactComponent };